import { Dropdown, SelectOption } from "components/dropdown/Dropdown";
import { SetStateAction, useEffect, useRef, useState } from "react";
import {
  ParsedWorkflowItem,
  ReferenceData,
  WorkflowActionTypes,
  WorkflowBuilderErrors,
  WorkflowReferenceDataNames,
} from "../WorkflowBuilderPage";
import { MultiDropdown } from "components/dropdown/MultiDropdown";
import _ from "lodash";
import {
  changeWorkflowBuilderReferenceData,
} from "./WorkflowItem";
import { Droppable } from "react-beautiful-dnd";
import { List } from "./MilestoneTaskPicker";

import deleteIcon from "assets/Icon_Form_Search_02.png";
import { MinimiseSelector } from "./TriggerTypeSelector";
import { EditNode } from "./DocumentUploadTrigger";
import { Modal } from "components/modal/Modal";

import dragAndDropIcon from "assets/drag_and_drop_icon.png";
import ToastMessage, { toastConfig } from "helpers/ToastMessage/ToastMessage";
import { toast } from "react-toastify";
import { customUseOnClickOutside } from "components/helpers/CustomFieldRenderers/SearchListFieldRenderer/SearchListRenderer";

interface Props {
  index: number;
  actionData: any;

  parsedData: ParsedWorkflowItem | null;
  setParsedData: React.Dispatch<SetStateAction<ParsedWorkflowItem | null>>;
  referenceData: ReferenceData | null;
  setReferenceData: React.Dispatch<SetStateAction<ReferenceData | null>>;
  actionTypes: WorkflowActionTypes[];
  uniqueId: string;
  tempActionMilestoneId: number | null;
  setTempActionMilestoneId: React.Dispatch<SetStateAction<number | null>>;
  tempActionMilestoneData: List | null;
  setTempActionMilestoneData: React.Dispatch<SetStateAction<List | null>>;
  tempActionDestinationMilestoneId: number | null;
  setTempActionDestinationMilestoneId: React.Dispatch<
    SetStateAction<number | null>
  >;
  milestonestasksList: List[] | null;
  setMilestonestasksList: React.Dispatch<SetStateAction<List[] | null>>;
  contactTypes: SelectOption[];
  userPools: SelectOption[];
  deleteAction: (idx: number) => void;
  workflowBuilderErrors: WorkflowBuilderErrors;
  setWorkflowBuilderErrors: React.Dispatch<
    SetStateAction<WorkflowBuilderErrors>
  >;
  documentOptions: SelectOption[];
  triggerDatesOptions: SelectOption[];
  workflows: SelectOption[];
}

type DeleteActionProps = {
  index: number;
  deleteAction: (idx: number) => void;
  type?: "icon" | "button";
};

const DeleteAction: React.FC<DeleteActionProps> = ({
  index,
  deleteAction,
  type = "icon",
}) => {
  const [showDeletePopUp, setShowDeletePopUp] = useState<boolean>(false);

  const confirmDelete = () => {
    deleteAction(index);
    setShowDeletePopUp(false);
  };

  const bind = customUseOnClickOutside(() => {
    setShowDeletePopUp(false);
  }, true);

  return (
    <div className="DeleteActionContainer">
      {type === "icon" && (
        <div
          className="DeleteBtn DeleteActionIcon"
          onClick={() => setShowDeletePopUp(true)}
        >
          <img src={deleteIcon} alt="Delete action" className="DeleteIcon" />
        </div>
      )}

      {type === "button" && (
        <button
          type="button"
          className="DeleteBtn DeleteActionButton"
          onClick={() => setShowDeletePopUp(true)}
        >
          Delete action
        </button>
      )}

      {showDeletePopUp && (
        <Modal
          open={showDeletePopUp}
          closeModal={() => {
            setShowDeletePopUp(false);
          }}
          title={`Delete action`}
          actionButton={
            <button className="Btn" onClick={confirmDelete}>
              Yes
            </button>
          }
          clearUnderlay={true}
          extraClassNames="DeleteWorkflowAction"
        >
          <div className="Text">
            Are you sure you want to delete this action?
          </div>
        </Modal>
      )}
    </div>
  );
};

const Action: React.FC<Props> = ({
  index,
  actionData,

  parsedData,
  setParsedData,
  referenceData,
  setReferenceData,
  actionTypes,
  uniqueId,
  tempActionMilestoneData,
  setTempActionMilestoneData,
  tempActionMilestoneId,
  setTempActionMilestoneId,
  tempActionDestinationMilestoneId,
  setTempActionDestinationMilestoneId,
  milestonestasksList,
  setMilestonestasksList,
  contactTypes,
  userPools,
  deleteAction,
  workflowBuilderErrors,
  setWorkflowBuilderErrors,
  documentOptions,
  triggerDatesOptions,
  workflows,
}) => {
  const [actionType, setActionType] = useState<number | null>(null);
  const [showActionTypeSelector, setShowActionTypeSelector] = useState<boolean>(
    false
  );
  const [milestoneUpdateData, setMilestoneUpdateData] = useState<List | null>(
    null
  );
  const [overwriteTask, setOverwriteTask] = useState<boolean>(false);
  const [excludeHolidays, setExcludeHolidays] = useState<boolean>(false);
  const [businessDay, setBusinessDay] = useState<boolean>(false);
  const [emailNotifications, setEmailNotifications] = useState<boolean>(false);

  const [workflowActionMessage, setWorkflowActionMessage] = useState<
    string | null
  >(null);

  const [relevantErrors, setRelevantErrors] = useState<string[] | null>(null);

  const [parsedActionTypes, setParsedActionTypes] = useState<{
    [id: number]: {
      internalCode: string | number;
      bEmailNotifications: boolean | null;
    };
  } | null>(null);

  const [workflowActionType, setWorkflowActionType] = useState<{
    internalCode: string | number | null;
    bEmailNotifications: boolean | null;
  }>({
    internalCode: null,
    bEmailNotifications: null,
  });

  useEffect(() => {
    if (
      actionTypes &&
      Array.isArray(actionTypes) &&
      actionTypes.length > 0 &&
      typeof actionTypes[0] === "object"
    ) {
      let tempParsedActionTypes: any = {};

      actionTypes.forEach(item => {
        tempParsedActionTypes[item.value] = {
          internalCode: item.internalCode,
          bEmailNotifications: item.bEmailNotifications,
        };
      });

      setParsedActionTypes(tempParsedActionTypes);
    } else {
      setParsedActionTypes(null);
    }
  }, [actionTypes]);

  const textareaRef = useRef<HTMLTextAreaElement>(null);
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [workflowActionMessage]);
  useEffect(() => {
    if (
      actionData &&
      actionData[index] &&
      actionData[index].workflowActionsID &&
      workflowBuilderErrors &&
      workflowBuilderErrors.actions &&
      workflowBuilderErrors.actions.hasOwnProperty(
        actionData[index].workflowActionsID
      )
    ) {
      const tempErrors =
        workflowBuilderErrors.actions[actionData[index].workflowActionsID];

      if (Array.isArray(tempErrors) && tempErrors.length > 0) {
        setRelevantErrors(tempErrors);
      } else {
        setRelevantErrors(null);
      }
    } else {
      setRelevantErrors(null);
    }
  }, [workflowBuilderErrors]);

  const [
    calculatedDataTaskToUpdate,
    setCalculatedDataTaskToUpdate,
  ] = useState<SelectOption | null>(null);
  const [
    calculatedDataTaskToBaseChangeOn,
    setCalculatedDataTaskToBaseChangeOn,
  ] = useState<SelectOption | null>(null);

  useEffect(() => {
    if (
      milestonestasksList &&
      Array.isArray(milestonestasksList) &&
      actionData &&
      actionData[index] &&
      actionData[index].updateTasksID &&
      typeof actionData[index].updateTasksID === "number" &&
      milestonestasksList.filter(
        item => actionData[index].updateTasksID === item.tasksId
      ).length === 1
    ) {
      const data = milestonestasksList.filter(
        item => actionData[index].updateTasksID === item.tasksId
      )[0];
      setCalculatedDataTaskToUpdate({
        label: data.tasksName,
        value: data.tasksId,
      });
    } else {
      setCalculatedDataTaskToUpdate(null);
    }
  }, [milestonestasksList, actionData]);

  useEffect(() => {
    if (
      milestonestasksList &&
      Array.isArray(milestonestasksList) &&
      actionData &&
      actionData[index] &&
      actionData[index].baseOnTasksID &&
      typeof actionData[index].baseOnTasksID === "number" &&
      milestonestasksList.filter(
        item => actionData[index].baseOnTasksID === item.tasksId
      ).length === 1
    ) {
      const data = milestonestasksList.filter(
        item => actionData[index].baseOnTasksID === item.tasksId
      )[0];
      setCalculatedDataTaskToBaseChangeOn({
        label: data.tasksName,
        value: data.tasksId,
      });
    } else {
      setCalculatedDataTaskToBaseChangeOn(null);
    }
  }, [milestonestasksList, actionData]);

  const [dateToUpdate, setDateToUpdate] = useState<SelectOption | null>(null);
  const [
    dateToBaseUpdateOn,
    setDateToBaseUpdateOn,
  ] = useState<SelectOption | null>(null);

  useEffect(() => {
    if (
      milestonestasksList &&
      Array.isArray(milestonestasksList) &&
      actionData &&
      actionData[index] &&
      actionData[index].updateDate &&
      triggerDatesOptions &&
      triggerDatesOptions.filter(
        item => actionData[index].updateDate === item.value
      ).length === 1
    ) {
      const data = triggerDatesOptions.filter(
        item => actionData[index].updateDate === item.value
      )[0];
      setDateToUpdate({
        label: data.label,
        value: data.value,
      });
    } else {
      setDateToUpdate(null);
    }
  }, [milestonestasksList, actionData, triggerDatesOptions]);

  useEffect(() => {
    if (
      milestonestasksList &&
      Array.isArray(milestonestasksList) &&
      actionData &&
      actionData[index] &&
      actionData[index].baseOnDate &&
      triggerDatesOptions &&
      triggerDatesOptions.filter(
        item => actionData[index].baseOnDate === item.value
      ).length === 1
    ) {
      const data = triggerDatesOptions.filter(
        item => actionData[index].baseOnDate === item.value
      )[0];

      setDateToBaseUpdateOn({
        label: data.label,
        value: data.value,
      });
    } else {
      setDateToBaseUpdateOn(null);
    }
  }, [milestonestasksList, actionData, triggerDatesOptions]);

  const [
    workflowToTrigger,
    setWorkflowToTrigger,
  ] = useState<SelectOption | null>(null);

  useEffect(() => {
    if (
      workflows &&
      Array.isArray(workflows) &&
      actionData &&
      actionData[index] &&
      actionData[index].workflowToTriggersID &&
      workflows.filter(
        item => actionData[index].workflowToTriggersID === item.value
      ).length === 1
    ) {
      const data = workflows.filter(
        item => actionData[index].workflowToTriggersID === item.value
      )[0];

      setWorkflowToTrigger({
        label: data.label,
        value: data.value,
      });
    } else {
      setWorkflowToTrigger(null);
    }
  }, [actionData, workflows]);

  const [
    workflowNotificationsDaysChange,
    setWorkflowNotificationsDaysChange,
  ] = useState<string | null>(null);

  useEffect(() => {
    if (actionData && actionData[index] && actionData[index].bOverwriteTask) {
      setOverwriteTask(true);
    } else {
      setOverwriteTask(false);
    }

    if (actionData && actionData[index] && actionData[index].bExcludeHolidays) {
      setExcludeHolidays(true);
    } else {
      setExcludeHolidays(false);
    }

    if (
      actionData &&
      actionData[index] &&
      actionData[index].bBusinessDaysOnly
    ) {
      setBusinessDay(true);
    } else {
      setBusinessDay(false);
    }

    if (
      actionData &&
      actionData[index] &&
      actionData[index].bEmailNotifications
    ) {
      setEmailNotifications(true);
    } else {
      setEmailNotifications(false);
    }

    if (actionData && actionData[index] && actionData[index].taskDayChange) {
      setWorkflowNotificationsDaysChange(actionData[index].taskDayChange);
    } else {
      setWorkflowNotificationsDaysChange(null);
    }

    if (actionData && actionData[index] && actionData[index].messageText) {
      setWorkflowActionMessage(actionData[index].messageText);
    } else {
      setWorkflowActionMessage(null);
    }

    if (
      actionData &&
      actionData[index] &&
      actionData[index].updateTasksID &&
      milestonestasksList &&
      !milestoneUpdateData
    ) {
      const match = milestonestasksList.filter(
        item => item.tasksId === actionData[index].updateTasksID
      );

      if (match && Array.isArray(match) && match.length === 1) {
        setMilestoneUpdateData(match[0]);
      } else {
        setMilestoneUpdateData(null);
      }
    }
  }, [actionData, milestonestasksList]);

  useEffect(() => {
    if (
      milestonestasksList &&
      tempActionMilestoneData &&
      tempActionMilestoneId &&
      actionData &&
      actionData[index] &&
      actionData[index].workflowActionsID &&
      tempActionDestinationMilestoneId &&
      tempActionDestinationMilestoneId === actionData[index].workflowActionsID
    ) {
      const match = milestonestasksList.filter(
        item => item.tasksId === tempActionMilestoneId
      );

      if (match.length === 1) {
        setMilestoneUpdateData(match[0]);

        let newReferenceData = _.cloneDeep(referenceData);

        newReferenceData = changeWorkflowBuilderReferenceData(
          newReferenceData,
          WorkflowReferenceDataNames.ACTIONS,
          "workflowActionsID",
          actionData[index].workflowActionsID ?? null,
          "updateTasksID",
          match[0].tasksId,
          "replace"
        );

        setReferenceData(newReferenceData);

        // Clear for next drag and drop
        setTempActionMilestoneId(null);
        setTempActionDestinationMilestoneId(null);
      }
    }
  }, [
    tempActionMilestoneData,
    tempActionMilestoneId,
    tempActionDestinationMilestoneId,
  ]);

  useEffect(() => {
    if (
      actionData &&
      actionData[index] &&
      actionData[index].workflowActionTypesID
    ) {
      setActionType(actionData[index].workflowActionTypesID);
      setShowActionTypeSelector(false);
    } else {
      setActionType(null);
      setShowActionTypeSelector(true);
    }
  }, [actionData]);

  const handleChangeAction = (option: SelectOption) => {
    let attemptChange: boolean = true;

    if (
      option.label.toLowerCase().trim() === "re-dispatch survey" &&
      referenceData &&
      referenceData.trigger &&
      referenceData.trigger.hasOwnProperty("workflowTriggerTypesID") &&
      referenceData.triggerTypes
    ) {
      const workflowTriggerTypesID =
        referenceData.trigger.workflowTriggerTypesID;

      const match = referenceData.triggerTypes.filter(
        (item: any) => item.id === workflowTriggerTypesID
      );

      if (
        match.length === 1 &&
        typeof match[0] === "object" &&
        match[0].hasOwnProperty("name")
      ) {
        const matchName = match[0].name.toLowerCase().trim();

        if (matchName !== "submitted survey") {
          attemptChange = false;

          toast(
            <ToastMessage
              toastData={[
                {
                  title: "Invalid Trigger",
                  text:
                    "Please select a 'Submitted survey' trigger to add a 'Re-dispatch survey' action",
                },
              ]}
              className="ToastError"
            />,
            {
              ...toastConfig,
            }
          );
        }
      }
    }

    if (attemptChange && parsedData) {
      const id = option.value;

      let tempActionData: any = null;

      if (
        actionData &&
        actionData[index] &&
        actionData[index].workflowActionsID &&
        referenceData &&
        referenceData.actions &&
        Array.isArray(referenceData.actions) &&
        referenceData.actions.length > 0 &&
        typeof referenceData.actions === "object"
      ) {
        const match = referenceData.actions.filter(
          (item: any) =>
            item.workflowActionsID === actionData[index].workflowActionsID
        );

        if (match.length === 1) {
          tempActionData = _.cloneDeep(match[0]);
        }
      }

      const keysToNotChange = [
        "orderNumber",
        "parentOrderNumber",
        "workflowActionsID",
        "workflowActionTypesID",
        "childWorkflowActionID",
        "childWorkflowApprovalID",
        "nodeFirstActionId",
        "nodeApprovalId",
        "bNewlyCreated",
      ];

      let keysChanged: string[] = [];

      if (tempActionData) {
        Object.keys(tempActionData).forEach((key: string) => {
          if (!keysToNotChange.includes(key)) {
            tempActionData[key] = null;
            keysChanged.push(key);
          }
        });
      }

      let newReferenceData = _.cloneDeep(referenceData);

      if (tempActionData) {
        Object.keys(tempActionData).forEach(key => {
          const value = tempActionData[key];
          newReferenceData = changeWorkflowBuilderReferenceData(
            referenceData,
            WorkflowReferenceDataNames.ACTIONS,
            "workflowActionsID",
            actionData &&
              actionData[index] &&
              actionData[index].workflowActionsID
              ? actionData[index].workflowActionsID
              : null,

            key,
            value,
            "replace"
          );
        });
      }

      newReferenceData = changeWorkflowBuilderReferenceData(
        referenceData,
        WorkflowReferenceDataNames.ACTIONS,
        "workflowActionsID",
        actionData && actionData[index] && actionData[index].workflowActionsID
          ? actionData[index].workflowActionsID
          : null,

        "workflowActionTypesID",
        id,
        "replace"
      );

      setReferenceData(newReferenceData);

      // Clear errors:

      if (
        actionData &&
        actionData[index] &&
        actionData[index].workflowActionsID &&
        workflowBuilderErrors &&
        workflowBuilderErrors.actions &&
        workflowBuilderErrors.actions.hasOwnProperty(
          actionData[index].workflowActionsID
        )
      ) {
        let tempActionsErrors = _.cloneDeep(workflowBuilderErrors.actions);
        delete tempActionsErrors[actionData[index].workflowActionsID];
        let tempErrors = _.cloneDeep(workflowBuilderErrors);

        tempErrors.actions = { ...tempActionsErrors };

        setWorkflowBuilderErrors(tempErrors);
      }

      // Clear action milestone data:
      if (tempActionMilestoneData) {
        setTempActionMilestoneData(null);
      }
      if (tempActionMilestoneId) {
        setTempActionMilestoneId(null);
      }
      if (tempActionDestinationMilestoneId) {
        setTempActionDestinationMilestoneId(null);
      }

      if (milestoneUpdateData) {
        setMilestoneUpdateData(null);
      }
    }
  };

  const handleBooleanChange = (fieldName: string) => {
    let newValue = false;

    if (fieldName === "bOverwriteTask") {
      newValue = !overwriteTask;
      setOverwriteTask(newValue);
    } else if (fieldName === "bExcludeHolidays") {
      newValue = !excludeHolidays;
      setExcludeHolidays(newValue);
    } else if (fieldName === "bEmailNotifications") {
      newValue = !emailNotifications;
      setEmailNotifications(newValue);
    }

    let newReferenceData = _.cloneDeep(referenceData);

    newReferenceData = changeWorkflowBuilderReferenceData(
      newReferenceData,
      WorkflowReferenceDataNames.ACTIONS,
      "workflowActionsID",
      actionData[index].workflowActionsID ?? null,
      fieldName,
      newValue,
      "replace"
    );

    setReferenceData(newReferenceData);
  };

  const handleRadioButtonsChange = (newValue: boolean, fieldName: string) => {
    if (fieldName === "bBusinessDaysOnly") {
      setBusinessDay(newValue);
    }

    let newReferenceData = _.cloneDeep(referenceData);

    newReferenceData = changeWorkflowBuilderReferenceData(
      newReferenceData,
      WorkflowReferenceDataNames.ACTIONS,
      "workflowActionsID",
      actionData[index].workflowActionsID ?? null,
      fieldName,
      newValue,
      "replace"
    );

    setReferenceData(newReferenceData);
  };

  const handleDropdownChangeMulti = (
    options: SelectOption[],
    fieldName: string
  ) => {
    const optionIds = options ? options.map(item => item.value) : null;

    let newReferenceData = _.cloneDeep(referenceData);

    newReferenceData = changeWorkflowBuilderReferenceData(
      newReferenceData,
      WorkflowReferenceDataNames.ACTIONS,
      "workflowActionsID",
      actionData[index].workflowActionsID ?? null,
      fieldName,
      optionIds,
      "replace"
    );

    setReferenceData(newReferenceData);
  };

  const handleDropdownChangeSingle = (
    option: SelectOption,
    fieldName: string
  ) => {
    const optionId = option ? option.value : null;

    let newReferenceData = _.cloneDeep(referenceData);

    newReferenceData = changeWorkflowBuilderReferenceData(
      newReferenceData,
      WorkflowReferenceDataNames.ACTIONS,
      "workflowActionsID",
      actionData[index].workflowActionsID ?? null,
      fieldName,
      optionId,
      "replace"
    );

    setReferenceData(newReferenceData);
  };

  const workflowActionMessageOnBlur = (
    type: "Action" | "Notifications" | "Reject Survey"
  ) => {
    let newReferenceData = _.cloneDeep(referenceData);

    let message = workflowActionMessage;

    newReferenceData = changeWorkflowBuilderReferenceData(
      newReferenceData,
      WorkflowReferenceDataNames.ACTIONS,
      "workflowActionsID",
      actionData[index].workflowActionsID ?? null,
      "messageText",
      message,
      "replace"
    );

    setReferenceData(newReferenceData);
  };

  const workflowActionDaysChangeOnBlur = () => {
    let newReferenceData = _.cloneDeep(referenceData);

    let daysChange = workflowNotificationsDaysChange;

    let parsedDaysChange = 0;

    try {
      parsedDaysChange = daysChange ? parseFloat(daysChange) : 0;
    } catch {
      console.log("Failed to parse days change: ", daysChange);
    }

    newReferenceData = changeWorkflowBuilderReferenceData(
      newReferenceData,
      WorkflowReferenceDataNames.ACTIONS,
      "workflowActionsID",
      actionData[index].workflowActionsID ?? null,
      "taskDayChange",
      parsedDaysChange,
      "replace"
    );

    setReferenceData(newReferenceData);
  };

  useEffect(() => {
    if (
      parsedActionTypes &&
      typeof actionType === "number" &&
      parsedActionTypes.hasOwnProperty(actionType) &&
      (typeof parsedActionTypes[actionType as keyof typeof parsedActionTypes]
        .internalCode === "string" ||
        typeof parsedActionTypes[actionType as keyof typeof parsedActionTypes]
          .internalCode === "number")
    ) {
      const internalCode =
        parsedActionTypes[actionType as keyof typeof parsedActionTypes]
          .internalCode;
      const emailNotifications =
        parsedActionTypes[actionType as keyof typeof parsedActionTypes]
          .bEmailNotifications;

      setWorkflowActionType({
        internalCode: internalCode,
        bEmailNotifications: emailNotifications,
      });
    } else {
      setWorkflowActionType({
        internalCode: null,
        bEmailNotifications: null,
      });
    }
  }, [actionType, parsedActionTypes]);

  return (
    <div className="ActionContainer">
      <div className="ActionTopVerticalNodeLine"></div>

      {showActionTypeSelector && (
        <div
          className={`Action ActionTypeSelector TriggerContainer DetailsItemContent ${
            relevantErrors && relevantErrors.length > 0 ? "Error" : ""
          }`}
        >
          <div className="Row">
            <div className="Label">Action type</div>

            <Dropdown
              onChange={handleChangeAction}
              value={
                actionType && actionTypes
                  ? actionTypes.find(o => o.value === actionType)
                  : null
              }
              options={actionTypes}
              placeholder="Please select"
              roundedRectangle
              portalMode={true}
              maxMenuHeight={150}
            />
          </div>

          <DeleteAction
            index={index}
            deleteAction={deleteAction}
            type="button"
          />

          {/* Only show if an action type is assinged to the action: */}

          {index > 0 && (
            <MinimiseSelector
              setShowSelector={setShowActionTypeSelector}
              selectedValue={true}
            />
          )}

          <div className="BottomVerticalNodeLine"></div>
        </div>
      )}

      {workflowActionType && (
        <div
          className={`ActionTypeContainer ${
            relevantErrors && relevantErrors.length > 0 ? "Error" : ""
          }`}
        >
          {workflowActionType.internalCode === "UPDATE_MILESTONE_OR_TASK" && (
            <>
              <label className="Title">
                <div className="Text">Milestone / tasks update</div>
                <EditNode setShowSelector={setShowActionTypeSelector} />
              </label>

              <DeleteAction index={index} deleteAction={deleteAction} />

              <Droppable
                droppableId={`droppableId-milestoneUpdateAction-${actionData[index].workflowActionsID}`}
                type={"group"}
              >
                {provided => (
                  <div
                    className="TaskMilestoneDropContainer"
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                  >
                    {!milestoneUpdateData &&
                      "Drag and drop Milestone/task here"}

                    {milestoneUpdateData && (
                      <div className="MilestoneData">
                        <img
                          src={dragAndDropIcon}
                          alt="drag and drop icon"
                          className="Icon"
                        />

                        <div className="Text">{`${milestoneUpdateData.tasksName}`}</div>
                      </div>
                    )}
                  </div>
                )}
              </Droppable>

              <div className="Row">
                <div className="Label">Date to update</div>

                <Dropdown
                  onChange={(e: any) =>
                    handleDropdownChangeSingle(e, "updateDate")
                  }
                  value={dateToUpdate}
                  options={
                    triggerDatesOptions
                      ? triggerDatesOptions.map(item => {
                          return { label: item.label, value: item.value };
                        })
                      : []
                  }
                  roundedRectangle
                  portalMode={true}
                  isClearable={true}
                />
              </div>

              <div className="Row">
                <div className="Label">
                  Overwrite current state:
                </div>

                <div
                  className="Radio"
                  role="radio"
                  aria-checked={overwriteTask}
                >
                  <input
                    id={`bOverwriteTaskCheckbox-${uniqueId}-${index}`}
                    type="radio"
                    name={`bOverwriteTaskCheckbox-${uniqueId}-${index}`}
                    value="bOverwriteTask"
                    onClick={() => handleBooleanChange("bOverwriteTask")}
                    checked={overwriteTask}
                  />
                  <label
                    className="CustomInput"
                    htmlFor={`bOverwriteTaskCheckbox-${uniqueId}-${index}`}
                  ></label>
                </div>
              </div>
            </>
          )}
          {workflowActionType.internalCode === "WORKFLOW_ACTION" && (
            <>
              <label className="Title">
                <div className="Text">Workflow action</div>
                <EditNode setShowSelector={setShowActionTypeSelector} />
              </label>

              <DeleteAction index={index} deleteAction={deleteAction} />

              <div className="Label">Message</div>
              <textarea
                ref={textareaRef}
                placeholder="Type your text here"
                onChange={e => setWorkflowActionMessage(e.target.value)}
                onBlur={() => workflowActionMessageOnBlur("Action")}
                value={workflowActionMessage ?? ""}
                className="ActionMessage"
              />

              <div className="Row">
                <div className="Label">Document type</div>

                <Dropdown
                  onChange={(e: any) =>
                    handleDropdownChangeSingle(e, "documentTypesID")
                  }
                  value={
                    documentOptions &&
                    Array.isArray(documentOptions) &&
                    actionData &&
                    actionData[index] &&
                    actionData[index].documentTypesID &&
                    typeof actionData[index].documentTypesID === "number" &&
                    documentOptions.filter(
                      item => actionData[index].documentTypesID === item.value
                    ).length === 1
                      ? documentOptions.filter(
                          item =>
                            actionData[index].documentTypesID === item.value
                        )[0]
                      : null
                  }
                  options={documentOptions}
                  roundedRectangle
                  portalMode={true}
                  isClearable={true}
                />
              </div>

              <div className="Row">
                <div className="Label">Contact types</div>

                <MultiDropdown
                  customClassName="MultiDropdown"
                  onChange={(e: any) =>
                    handleDropdownChangeMulti(e, "contactTypesIDs")
                  }
                  value={
                    contactTypes &&
                    Array.isArray(contactTypes) &&
                    actionData &&
                    actionData[index] &&
                    actionData[index].contactTypesIDs &&
                    Array.isArray(actionData[index].contactTypesIDs)
                      ? contactTypes.filter(item =>
                          actionData[index].contactTypesIDs.includes(item.value)
                        )
                      : null
                  }
                  options={contactTypes}
                  roundedRectangle
                  portalMode={true}
                />
              </div>

              <div className="Row">
                <div className="Label">Userpool</div>

                <Dropdown
                  onChange={(e: any) =>
                    handleDropdownChangeSingle(e, "userPoolsID")
                  }
                  value={
                    userPools &&
                    Array.isArray(userPools) &&
                    actionData &&
                    actionData[index] &&
                    actionData[index].userPoolsID &&
                    typeof actionData[index].userPoolsID === "number" &&
                    userPools.filter(
                      item => actionData[index].userPoolsID === item.value
                    ).length === 1
                      ? userPools.filter(
                          item => actionData[index].userPoolsID === item.value
                        )[0]
                      : null
                  }
                  options={userPools}
                  roundedRectangle
                  portalMode={true}
                  isClearable={true}
                />
              </div>
            </>
          )}

          {workflowActionType.internalCode === "WORKFLOW_NOTIFICATION" && (
            <>
              <label className="Title">
                <div className="Text">Workflow notifications</div>
                <EditNode setShowSelector={setShowActionTypeSelector} />
              </label>

              <DeleteAction index={index} deleteAction={deleteAction} />

              <div className="Label">Message</div>
              <textarea
                ref={textareaRef}
                placeholder="Type your text here"
                onChange={e => setWorkflowActionMessage(e.target.value)}
                onBlur={() => workflowActionMessageOnBlur("Notifications")}
                value={workflowActionMessage ?? ""}
                className="ActionMessage"
              />

              <div className="Row">
                <div className="Label">Contact types</div>

                <MultiDropdown
                  customClassName="MultiDropdown"
                  onChange={(e: any) =>
                    handleDropdownChangeMulti(e, "contactTypesIDs")
                  }
                  value={
                    contactTypes &&
                    Array.isArray(contactTypes) &&
                    actionData &&
                    actionData[index] &&
                    actionData[index].contactTypesIDs &&
                    Array.isArray(actionData[index].contactTypesIDs)
                      ? contactTypes.filter(item =>
                          actionData[index].contactTypesIDs.includes(item.value)
                        )
                      : null
                  }
                  options={contactTypes}
                  roundedRectangle
                  portalMode={true}
                />
              </div>

              <div className="Row">
                <div className="Label">Userpool</div>

                <Dropdown
                  onChange={(e: any) =>
                    handleDropdownChangeSingle(e, "userPoolsID")
                  }
                  value={
                    userPools &&
                    Array.isArray(userPools) &&
                    actionData &&
                    actionData[index] &&
                    actionData[index].userPoolsID &&
                    typeof actionData[index].userPoolsID === "number" &&
                    userPools.filter(
                      item => actionData[index].userPoolsID === item.value
                    ).length === 1
                      ? userPools.filter(
                          item => actionData[index].userPoolsID === item.value
                        )[0]
                      : null
                  }
                  options={userPools}
                  roundedRectangle
                  portalMode={true}
                  isClearable={true}
                />
              </div>
            </>
          )}

          {workflowActionType.internalCode === "CALCULATED_DATE" && (
            <>
              <label className="Title">
                <div className="Text">Calculated date</div>
                <EditNode setShowSelector={setShowActionTypeSelector} />
              </label>

              <DeleteAction index={index} deleteAction={deleteAction} />

              <div className="Row">
                <div className="Label">Milestone/task to update</div>

                <Dropdown
                  onChange={(e: any) =>
                    handleDropdownChangeSingle(e, "updateTasksID")
                  }
                  value={calculatedDataTaskToUpdate}
                  options={
                    milestonestasksList
                      ? milestonestasksList.map(item => {
                          return {
                            label: item.tasksName,
                            value: item.tasksId,
                          };
                        })
                      : []
                  }
                  roundedRectangle
                  portalMode={true}
                  isClearable={true}
                />
              </div>

              <div className="Row">
                <div className="Label">
                  Milestone/task to base data change on
                </div>

                <Dropdown
                  onChange={(e: any) =>
                    handleDropdownChangeSingle(e, "baseOnTasksID")
                  }
                  value={calculatedDataTaskToBaseChangeOn}
                  options={
                    milestonestasksList
                      ? milestonestasksList.map(item => {
                          return {
                            label: item.tasksName,
                            value: item.tasksId,
                          };
                        })
                      : []
                  }
                  roundedRectangle
                  portalMode={true}
                  isClearable={true}
                />
              </div>

              <div className="Row">
                <div className="Label">Days to add/subtract</div>

                <input
                  type="number"
                  onChange={e =>
                    setWorkflowNotificationsDaysChange(e.target.value)
                  }
                  onBlur={() => workflowActionDaysChangeOnBlur()}
                  value={workflowNotificationsDaysChange ?? 0}
                />
              </div>

              <div className="Row">
                <div className="RadioButtonsContainer">
                  <div
                    className={`RadioContainer ${businessDay ? "Active" : ""}`}
                    onClick={() =>
                      handleRadioButtonsChange(true, "bBusinessDaysOnly")
                    }
                  >
                    <div className="Label">Business days</div>

                    <div
                      className="Radio"
                      role="radio"
                      aria-checked={businessDay}
                    >
                      <input
                        id={`bBusinessDayYesCheckbox-${uniqueId}-${index}`}
                        type="radio"
                        name={`bBusinessDayYesCheckbox-${uniqueId}-${index}`}
                        value="bBusinessDayYes"
                        checked={businessDay}
                      />
                      <label
                        className="CustomInput"
                        htmlFor={`bBusinessDayYesCheckbox-${uniqueId}-${index}`}
                      ></label>
                    </div>
                  </div>

                  <div
                    className={`RadioContainer ${!businessDay ? "Active" : ""}`}
                    onClick={() =>
                      handleRadioButtonsChange(false, "bBusinessDaysOnly")
                    }
                  >
                    <div className="Label">Calendar days</div>

                    <div
                      className="Radio"
                      role="radio"
                      aria-checked={!businessDay}
                    >
                      <input
                        id={`bBusinessDayNoCheckbox-${uniqueId}-${index}`}
                        type="radio"
                        name={`bBusinessDayNoCheckbox-${uniqueId}-${index}`}
                        value="bBusinessDayNo"
                        checked={!businessDay}
                      />
                      <label
                        className="CustomInput"
                        htmlFor={`bBusinessDayNoCheckbox-${uniqueId}-${index}`}
                      ></label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="Row">
                <div className="Label">Date to update</div>

                <Dropdown
                  onChange={(e: any) =>
                    handleDropdownChangeSingle(e, "updateDate")
                  }
                  value={dateToUpdate}
                  options={
                    triggerDatesOptions
                      ? triggerDatesOptions.map(item => {
                          return { label: item.label, value: item.value };
                        })
                      : []
                  }
                  roundedRectangle
                  portalMode={true}
                  isClearable={true}
                />
              </div>

              <div className="Row">
                <div className="Label">Date to base data change on</div>

                <Dropdown
                  onChange={(e: any) =>
                    handleDropdownChangeSingle(e, "baseOnDate")
                  }
                  value={dateToBaseUpdateOn}
                  options={
                    triggerDatesOptions
                      ? triggerDatesOptions.map(item => {
                          return { label: item.label, value: item.value };
                        })
                      : []
                  }
                  roundedRectangle
                  portalMode={true}
                  isClearable={true}
                />
              </div>

              <div className="Row">
                <div className="Label">Exclude holidays</div>

                <div
                  className="Radio"
                  role="radio"
                  aria-checked={excludeHolidays}
                >
                  <input
                    id={`bExcludeHolidaysCheckbox-${uniqueId}-${index}`}
                    type="radio"
                    name={`bExcludeHolidaysCheckbox-${uniqueId}-${index}`}
                    value="bExcludeHolidays"
                    onClick={() => handleBooleanChange("bExcludeHolidays")}
                    checked={excludeHolidays}
                  />
                  <label
                    className="CustomInput"
                    htmlFor={`bExcludeHolidaysCheckbox-${uniqueId}-${index}`}
                  ></label>
                </div>
              </div>
            </>
          )}

          {workflowActionType.internalCode === "TRIGGER_WORKFLOW" && (
            <>
              <label className="Title">
                <div className="Text">Trigger workflow</div>
                <EditNode setShowSelector={setShowActionTypeSelector} />
              </label>

              <DeleteAction index={index} deleteAction={deleteAction} />

              <div className="Row">
                <div className="Label">Workflow</div>

                <Dropdown
                  onChange={(e: any) =>
                    handleDropdownChangeSingle(e, "workflowToTriggersID")
                  }
                  value={workflowToTrigger}
                  options={workflows ?? []}
                  roundedRectangle
                  portalMode={true}
                  isClearable={true}
                />
              </div>
            </>
          )}

          {workflowActionType.internalCode === "REJECT_SURVEY" && (
            <>
              <label className="Title">
                <div className="Text">Reject survey</div>
                <EditNode setShowSelector={setShowActionTypeSelector} />
              </label>

              <DeleteAction index={index} deleteAction={deleteAction} />

              <div className="Label">Message</div>

              <textarea
                ref={textareaRef}
                placeholder="Type your text here"
                onChange={e => setWorkflowActionMessage(e.target.value)}
                onBlur={() => workflowActionMessageOnBlur("Reject Survey")}
                value={workflowActionMessage ?? ""}
                className="ActionMessage"
              />
            </>
          )}

          {workflowActionType.internalCode === "TESTING_TYPE" && (
            <>
              <label className="Title">
                <div className="Text">Testing type</div>
                <EditNode setShowSelector={setShowActionTypeSelector} />
              </label>

              <DeleteAction index={index} deleteAction={deleteAction} />
            </>
          )}

          {workflowActionType.internalCode === "REDISPATCH_SURVEY" && (
            <>
              <label className="Title">
                <div className="Text">Re-dispatch survey</div>

                <EditNode setShowSelector={setShowActionTypeSelector} />
              </label>

              <DeleteAction index={index} deleteAction={deleteAction} />
            </>
          )}

          {workflowActionType.internalCode === "ADVANCED_CALCULATED_DATE" && (
            <>
              <label className="Title">
                <div className="Text">Advanced calculated date</div>
                <EditNode setShowSelector={setShowActionTypeSelector} />
              </label>

              <DeleteAction index={index} deleteAction={deleteAction} />

              <div className="Row">
                <div className="Label">Milestone/task to update</div>

                <Dropdown
                  onChange={(e: any) =>
                    handleDropdownChangeSingle(e, "updateTasksID")
                  }
                  value={calculatedDataTaskToUpdate}
                  options={
                    milestonestasksList
                      ? milestonestasksList.map(item => {
                          return {
                            label: item.tasksName,
                            value: item.tasksId,
                          };
                        })
                      : []
                  }
                  roundedRectangle
                  portalMode={true}
                  isClearable={true}
                />
              </div>

              <div className="Row">
                <div className="Label">
                  Milestone/task to base data change on
                </div>

                <Dropdown
                  onChange={(e: any) =>
                    handleDropdownChangeSingle(e, "baseOnTasksID")
                  }
                  value={calculatedDataTaskToBaseChangeOn}
                  options={
                    milestonestasksList
                      ? milestonestasksList.map(item => {
                          return {
                            label: item.tasksName,
                            value: item.tasksId,
                          };
                        })
                      : []
                  }
                  roundedRectangle
                  portalMode={true}
                  isClearable={true}
                />
              </div>

              <div className="Row">
                <div className="RadioButtonsContainer">
                  <div
                    className={`RadioContainer ${businessDay ? "Active" : ""}`}
                    onClick={() =>
                      handleRadioButtonsChange(true, "bBusinessDaysOnly")
                    }
                  >
                    <div className="Label">Business days</div>

                    <div
                      className="Radio"
                      role="radio"
                      aria-checked={businessDay}
                    >
                      <input
                        id={`bBusinessDayYesCheckbox-${uniqueId}-${index}`}
                        type="radio"
                        name={`bBusinessDayYesCheckbox-${uniqueId}-${index}`}
                        value="bBusinessDayYes"
                        checked={businessDay}
                      />
                      <label
                        className="CustomInput"
                        htmlFor={`bBusinessDayYesCheckbox-${uniqueId}-${index}`}
                      ></label>
                    </div>
                  </div>

                  <div
                    className={`RadioContainer ${!businessDay ? "Active" : ""}`}
                    onClick={() =>
                      handleRadioButtonsChange(false, "bBusinessDaysOnly")
                    }
                  >
                    <div className="Label">Calendar days</div>

                    <div
                      className="Radio"
                      role="radio"
                      aria-checked={!businessDay}
                    >
                      <input
                        id={`bBusinessDayNoCheckbox-${uniqueId}-${index}`}
                        type="radio"
                        name={`bBusinessDayNoCheckbox-${uniqueId}-${index}`}
                        value="bBusinessDayNo"
                        checked={!businessDay}
                      />
                      <label
                        className="CustomInput"
                        htmlFor={`bBusinessDayNoCheckbox-${uniqueId}-${index}`}
                      ></label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="Row">
                <div className="Label">Date to update</div>

                <Dropdown
                  onChange={(e: any) =>
                    handleDropdownChangeSingle(e, "updateDate")
                  }
                  value={dateToUpdate}
                  options={
                    triggerDatesOptions
                      ? triggerDatesOptions.map(item => {
                          return { label: item.label, value: item.value };
                        })
                      : []
                  }
                  roundedRectangle
                  portalMode={true}
                  isClearable={true}
                />
              </div>

              <div className="Row">
                <div className="Label">Date to base data change on</div>

                <Dropdown
                  onChange={(e: any) =>
                    handleDropdownChangeSingle(e, "baseOnDate")
                  }
                  value={dateToBaseUpdateOn}
                  options={
                    triggerDatesOptions
                      ? triggerDatesOptions.map(item => {
                          return { label: item.label, value: item.value };
                        })
                      : []
                  }
                  roundedRectangle
                  portalMode={true}
                  isClearable={true}
                />
              </div>

              <div className="Row">
                <div className="Label">Exclude holidays</div>

                <div
                  className="Radio"
                  role="radio"
                  aria-checked={excludeHolidays}
                >
                  <input
                    id={`bExcludeHolidaysCheckbox-${uniqueId}-${index}`}
                    type="radio"
                    name={`bExcludeHolidaysCheckbox-${uniqueId}-${index}`}
                    value="bExcludeHolidays"
                    onClick={() => handleBooleanChange("bExcludeHolidays")}
                    checked={excludeHolidays}
                  />
                  <label
                    className="CustomInput"
                    htmlFor={`bExcludeHolidaysCheckbox-${uniqueId}-${index}`}
                  ></label>
                </div>
              </div>
            </>
          )}

          {workflowActionType.bEmailNotifications && (
            <div className="Row">
              <div className="Label">Email notifications</div>

              <div
                className="Radio"
                role="radio"
                aria-checked={emailNotifications}
              >
                <input
                  id={`bEmailNotificationsCheckbox-${uniqueId}-${index}`}
                  type="radio"
                  name={`bEmailNotificationsCheckbox-${uniqueId}-${index}`}
                  value="bEmailNotifications"
                  onClick={() => handleBooleanChange("bEmailNotifications")}
                  checked={emailNotifications}
                />
                <label
                  className="CustomInput"
                  htmlFor={`bEmailNotificationsCheckbox-${uniqueId}-${index}`}
                ></label>
              </div>
            </div>
          )}

          {relevantErrors && relevantErrors.length > 0 && (
            <div className="Errors">
              {relevantErrors.map(error => {
                return <div className="Error">{error}</div>;
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Action;
